import React from 'react';
import { useRepositories } from '../hooks/useRepositories';
import { RepositoryList } from '../components/repositories/RepositoryList';
import { FolderGit2, Plus, RefreshCw } from 'lucide-react';
import { apiService } from '../services/api';

export function Repositories() {
  const { repositories, loading, error, refetch } = useRepositories();

  const handleSync = async (fullName: string) => {
    try {
      await apiService.syncRepository(fullName);
      await refetch();
    } catch (err) {
      console.error('Failed to sync repository:', err);
    }
  };

  const handleSyncAll = async () => {
    try {
      // Sync all repositories
      await Promise.all(
        repositories.map(async (repo) => {
          const fullName = repo.fullName || `${repo.owner}/${repo.name}`;
          return apiService.syncRepository(fullName);
        })
      );
      await refetch();
    } catch (err) {
      console.error('Failed to sync repositories:', err);
    }
  };

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FolderGit2 className="h-8 w-8 text-blue-600" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Repositories</h1>
            <p className="text-gray-600 mt-1">Manage your repository fleet</p>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleSyncAll}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2"
          >
            <RefreshCw className="h-5 w-5" />
            Sync All
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2">
            <Plus className="h-5 w-5" />
            Add Repository
          </button>
        </div>
      </div>

      {/* Repository List */}
      <RepositoryList
        repositories={repositories}
        loading={loading}
        error={error}
        onSync={handleSync}
      />
    </div>
  );
}
